import { Accordion } from './Accordion'
import { withAccordion } from './withAccordion'

const ConnectedAccordion = withAccordion(Accordion)

export { ConnectedAccordion as Accordion }
